import React, { createContext, useContext, useState, useEffect } from 'react';

const ProviderContext = createContext();

export const useProvider = () => {
  const context = useContext(ProviderContext);
  if (!context) {
    throw new Error('useProvider must be used within ProviderProvider');
  }
  return context;
};

export const ProviderProvider = ({ children }) => {
  const [provider, setProvider] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check for existing session
    const storedProvider = localStorage.getItem('provider');
    if (storedProvider) {
      try {
        const providerData = JSON.parse(storedProvider);
        setProvider(providerData);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Error loading provider session:', error);
        localStorage.removeItem('provider');
      }
    }
  }, []);

  const login = (providerData) => {
    setProvider(providerData);
    setIsAuthenticated(true);
    localStorage.setItem('provider', JSON.stringify(providerData));
  };

  const logout = () => {
    setProvider(null);
    setIsAuthenticated(false);
    localStorage.removeItem('provider');
  };

  const updateProvider = (updates) => {
    const updatedProvider = { ...provider, ...updates };
    setProvider(updatedProvider);
    localStorage.setItem('provider', JSON.stringify(updatedProvider));
  };

  return (
    <ProviderContext.Provider
      value={{
        provider,
        isAuthenticated,
        login,
        logout,
        updateProvider
      }}
    >
      {children}
    </ProviderContext.Provider>
  );
};
